<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div >
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="核查时间" >
              <a-range-picker v-model:value="queryParamDateRange" @change="queryParamDateRangeChange" />
            </a-form-item>
          </a-col>

          <a-col :span="12">
                <span style="float: left;overflow: hidden;" >
                  <a-button size="small" type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button size="small" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="small"
        :customRow="customRowFn"
        rowKey="id"
        :columns="columns"
        :rowClassName="rowClassName"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
      </a-table>
    </div>
  </a-card>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import { getAction } from '@/api/manage'

  export default {
    name: "VoiceDataList",
    mixins:[JeecgListMixin],
    components: {
    },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParamDateRange:[],
        dataSource:[],
        currentRow:null,
      // 表头
        columns: [
          {
            title: '时间',
            align:"center",
            width:150,
            dataIndex: 'createTime'
          },
          {
            title: '周期',
            align:"center",
            width:100,
            dataIndex: 'periodItemName'
          },
          {
            title: '表单',
            align:"center",
            ellipsis: true, //表格省略
            dataIndex: 'formName'
          },
          {
            title: '数量',
            align:"center",
            width:50,
            dataIndex: 'formNum'
          },
          {
            title: '状态',
            align:"center",
            width:100,
            dataIndex: 'status',
            customRender:(value,row,index)=>{
              let result = '申请中'
              if(value=='2'){
                result = '核查中'
              }else if(value =='3'){
                result = '已完成'
              }
              return result
            }
          },
        ],
        url: {
          list: "/voice/voiceApply/list",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
    },
    methods: {
      queryParamDateRangeChange(date, dateString){
        this.queryParam.createTime_begin = dateString[0]
        this.queryParam.createTime_end = dateString[1]
      },
      rowClassName(record){
        if(this.currentRow && this.currentRow.id ===record.id){
          return 'select-row'
        }
        return ''
      },
      customRowFn(record) {
        return {
          on: {
            click: () => {
              this.currentRow=record
              this.$emit('selectRow',record)
            }
          }
        }
      },
    }
  }
</script>
<style scoped lang="less">

</style>
<style  lang="less">
  .select-row{
    background-color: rgba(0,0,0,0.2);
  }
</style>